import { ReactNode } from 'react'
import { LoaderCircle } from 'lucide-react'
import { Button } from '@playbooks/ui/components/button'
import { cn } from '@playbooks/ui/lib/utils'

interface ButtonProps {
  label: string
  accentColor: string
  onClick?: () => void
  icon?: ReactNode
  disabled?: boolean
  className?: string
  loading?: boolean
}

const LoaderButton = ({ label, onClick, icon, disabled, className, loading, accentColor }: ButtonProps) => {
  return (
    <Button
      ref={ref => {
        if (!ref) return
        ref.style.width = `${ref.offsetWidth}px`
      }}
      onClick={onClick}
      className={cn('group px-4', className)}
      disabled={disabled}
      style={{ background: accentColor, borderColor: accentColor }}
    >
      <div
        className={cn(
          'flex items-center justify-center gap-2 text-white group-hover:opacity-100 opacity-70',
          loading && 'opacity-100',
        )}
      >
        {loading ? (
          <div className="py-1">
            <LoaderCircle className="animate-spin" />
          </div>
        ) : (
          <>
            {icon}
            <span>{label}</span>
          </>
        )}
      </div>
    </Button>
  )
}

export default LoaderButton
